<template>
  <cards class="menu-card">
    <div class="d-flex flex-column">
      <el-image
        v-if="item.image"
        class="menu-item-image"
        :src="item.image"
        fit="cover"
      >
        <div slot="placeholder" class="image-slot">
          <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
        </div>
        <div slot="error" class="image-slot text">
          <el-image
            class="menu-item-image w-100"
            src="img/menu-item-no-image.jpg"
            fit="cover"
          ></el-image>
        </div>
      </el-image>
      <div class="wrapper-menu-Item">
        <div
          class="box favorite clickable"
          @click="addRemoveFavorit(item, item.id)"
        >
          <i
            class="new-ui-icons"
            :class="{
              'fa fa-spinner fa-spin': isLoading[item.id],
              'k-icon-tab-favourites fav':
                !isLoading[item.id] && item.is_favourite,
              'k-icon-heart-line not-fav':
                !isLoading[item.id] && !item.is_favourite,
            }"
          ></i>
        </div>
        <div class="box details">
          <p class="title" :style="{ color: myTheme.primaryTextColor }">
            {{ item.name }}
          </p>
          <p class="description">{{ item.description }}</p>
          <p class="availability-date" v-if="item.is_special">
            {{
              $t("text.available_until", {
                date_time: $moment(specialEndDate).format("YYYY-MM-DD"),
              })
            }}
          </p>
          <div
            class="availability-date"
            v-else-if="item.mealDays.length || item.mealTimes.length"
          >
            {{ $t("text.available") }} :
            <span>{{ getFormatedAvailableDays(item.mealDays) }}</span>
            <span
              v-for="(mealTime, index) in item.mealTimes"
              :key="`mealtime_${index}`"
              >{{
                `${$t("text.from")} ${mealTime.start_at} ${$t("text.to")} ${
                  mealTime.end_at
                }`
              }}</span
            >
          </div>

          <div
            class="d-inline dietry-requirements"
            v-for="(dieatry, index) in getHelpers.getMenuItemDieatriesIcons(
              item
            )"
            :key="index"
          >
            <i
              class="new-ui-icons mr-1"
              :class="dieatry.icon"
              :title="dieatry.name"
            ></i>
          </div>
        </div>
        <div class="box price text-center my-auto">
          <span v-if="item.hasOptions">{{ $t("text.from") }}</span>
          {{ getPrice | currency(currentCurrency) }}
        </div>
        <div class="box counter text-center my-auto">
          <div class="btn-group-vertical add">
            <n-button
              type="success"
              icon
              round
              @click="sendItemToParent(item)"
              :disabled="disableAddButton"
            >
              <i class="k-icon-plus"></i>
            </n-button>
          </div>
        </div>
      </div>
    </div>
  </cards>
</template>
<script>
import {
  Button,
  Cards,
  RadioButton,
  FormTexterea,
  CheckboxButton,
} from "@/components";
import { InputNumber } from "element-ui";
import { mapActions, mapGetters, mapState } from "vuex";
import { helpers, enumHelper } from "@/utilities";
import router from "@/router";
import Vue from "vue";
export default {
  components: {
    [Button.name]: Button,
    Cards,
    [CheckboxButton.name]: CheckboxButton,
    [InputNumber.name]: InputNumber,
    [FormTexterea.name]: FormTexterea,
    [RadioButton.name]: RadioButton,
  },
  data() {
    return {
      enumHelper,
      isLoading: [],
      getHelpers: helpers,
      disable: false,
    };
  },
  props: {
    item: Object,
    cart: Object,
    specialStartDate: String,
    specialEndDate: String,
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    ...mapState({
      user: (state) => state.auth.user,
    }),
    getPrice: function () {
      return helpers.getMenuItemPrice(this.item, this.cart.orderType);
    },
    disableAddButton() {
      return this.disable || this.maxItemsReached();
    },
  },
  methods: {
    ...mapActions(["addToFavorite", "deleteFavorite"]),
    addRemoveFavorit(item, index) {
      if (!this.isAuthenticated || this.user == null) {
        let message = this.$t("message.login_to_add_favourite");
        let options = {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          okText: this.$t("button.go_to_login"),
          cancelText: this.$t("button.cancel"),
          animation: "fade", // Available: "zoom", "bounce", "fade"
          type: "basic", // coming soon: 'soft', 'hard'
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: "confirm", // Custom class to be injected into the parent node for the current dialog instance
        };
        this.$dialog
          .confirm(message, options)
          .then(function () {
            router.push({ name: "login", query: { redirect: "/menu" } });
          })
          .catch(() => {});
        return;
      }
      Vue.set(this.isLoading, index, 1);
      let obj = {
        menu_item_id: item.menu_item_id,
        location_id: this.selectedLocation.id,
      };
      if (!item.is_favourite) {
        this.addToFavorite(obj)
          .then(() => {
            item.is_favourite = true;
            Vue.set(this.isLoading, index, 0);
          })
          .catch((e) => {
            this.captureException(e);
            Vue.set(this.isLoading, index, 0);
          });
      } else {
        this.deleteFavorite(obj)
          .then(() => {
            item.is_favourite = false;
            Vue.set(this.isLoading, index, 0);
          })
          .catch((e) => {
            this.captureException(e);
            Vue.set(this.isLoading, index, 0);
          });
      }
    },
    async sendItemToParent(_item) {
      // check the user has a phone number or not
      if (this.isAuthenticated && (!this.user.telephone_number || !this.user.first_name || !this.user.last_name) ) {
        const confirmOptions = {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "CANCEL",
          customClass: "wtf-confirm",
          confirmButtonClass: "w-50 py-3",
          cancelButtonClass: "w-25 py-3",
          showClose: false,
          center: true,
          closeOnClickModal: false,
          type: "primary",
        };
        const missingField = !this.user.telephone_number ? 'a phone number' :  'first name and last name'
        const message = `<img src="img/dino/dino-cart.svg"></img> <p class="bigText">To add items to your cart, please add ${missingField} to your account</p>`;
        await this.$confirm(message,confirmOptions)
        .then(() => {
          router.push({name:'account', query:{redirectTo:'menu'}})
        })
        .catch(() => {
           return false;
        });
        return false;
      }
      //--- before pushing the iem, make sur is available for today/now
      if (this.itemAvailble()) {
        if (_item.hasOptions) {
          this.fetchMenuItem(this.selectedLocation.id, _item.id).then(
            (response) => {
              this.$root.$emit("PUSH_ITEM", {
                item: response.data,
                openModal: true,
                editMode: false,
              });
              this.disable = false;
            }
          );
        } else {
          this.$root.$emit("PUSH_ITEM", {
            item: _item,
            openModal: false,
            editMode: false,
          });
          this.disable = false;
        }
      } else {
        this.disable = true;
        this.$notify({
          group: "bottomRight",
          title: this.$t("message.item_removed_notify_title"),
          type: "warn",
          text: this.$t("message.item_removed_notify_message", {
            item_name: _item.name,
          }),
        });
      }
    },
    itemAvailble() {
      let dayNumber = this.$moment().format("d");
      let nowTime = this.$moment().format("HH:mm:ss");
      return (
        helpers.orderItemsAvailibilityforToday(this.item, dayNumber) &&
        helpers.orderItemAvailibilityforNow(this.item, nowTime)
      );
    },
    getFormatedAvailableDays(mealDays) {
      let days = mealDays.map(function (x) {
        return Array.isArray(x.days) ? x.days : JSON.parse(x.days);
      });

      days = Array.from(new Set([].concat(...days))).sort();
      let daysNames = days.map((x) => this.$moment().day(x).format("dddd"));
      return daysNames.join(", ");
    },
    maxItemsReached() {
      if (this.item.options && this.item.options.length) return false;
      let currentCartItem = this.cart.order.find((x) => x.id == this.item.id);

      return currentCartItem && currentCartItem.quantity >= enumHelper.maxItems;
    },
  },
};
</script>
<style scoped>
.form-group.input-group,
.form-group.input-group {
  padding: 0 !important;
}
</style>
<style>
.el-input-number__decrease,
.el-input-number__increase {
  height: 96% !important;
}
</style>
